var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2933 0.705809C14.8401 0.253273 14.2258 -0.000900269 13.5853 -0.000900269C12.9449 -0.000900269 12.3306 0.253273 11.8773 0.705809L0 12.5831V15.9991H3.416L15.2933 4.12181C15.7457 3.66849 15.9998 3.05423 15.9998 2.41381C15.9998 1.77339 15.7457 1.15913 15.2933 0.705809ZM2.86667 14.6658H1.33333V13.1325L10.2067 4.26581L11.74 5.79914L2.86667 14.6658ZM14.3507 3.17914L12.6793 4.85048L11.1493 3.31714L12.82 1.64848C13.0233 1.44514 13.2991 1.33091 13.5867 1.33091C13.8742 1.33091 14.15 1.44514 14.3533 1.64848C14.5567 1.85181 14.6709 2.12759 14.6709 2.41514C14.6709 2.7027 14.5567 2.97848 14.3533 3.18181L14.3507 3.17914Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.34ebafd03e0d25767ea288759e253d4c.svg";
export { ForwardRef as ReactComponent };